import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { auth } from './modules/auth';
import { loading } from './modules/loading';
import { message } from './modules/message';
import { tab } from './modules/tab';
import { userAgent } from './modules/user_agent';
import { companyContractTag } from './modules/company_contract_tag';
import { user } from './modules/user';
import { showHeader } from './modules/showHeader';
import { version } from './modules/version';
import { category } from './modules/category';

// Status List
import { languageCode } from './status_list/language_code';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    loading,
    message,
    tab,
    userAgent,
    languageCode,
    companyContractTag,
    user,
    showHeader,
    version,
    category
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: [
        'auth',
        'loading',
        'message',
        'tab',
        'userAgent',
        'languageCode',
        'companyContractTag',
        'user',
        'showHeader',
        'version',
        'category'
      ]
    })
  ]
});
